"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TabStyled = require("./Tab-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TabTitle = function TabTitle(_ref) {
  var children = _ref.children,
      index = _ref.index,
      activeTabIndex = _ref.activeTabIndex,
      setActiveTabIndex = _ref.setActiveTabIndex,
      other = _objectWithoutProperties(_ref, ["children", "index", "activeTabIndex", "setActiveTabIndex"]);

  var handleSetActiveTabIndex = function handleSetActiveTabIndex(e) {
    setActiveTabIndex(e, index);
  };

  return _react.default.createElement(_TabStyled.StyledTabTitle, _extends({
    onClick: handleSetActiveTabIndex,
    active: activeTabIndex === index
  }, other), children);
};

TabTitle.propTypes = {
  /** The text content of the component. */
  children: _propTypes.default.node
};
TabTitle.defaultProps = {};
TabTitle.displayName = 'TabTitle';
var _default = TabTitle;
exports.default = _default;